import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	data: [],
	loading: false,
	loadingComplete: false,
	error: null,
	timeStamp: null
};

const defaultCategoriesSlice = createSlice({
	name: 'defaultCategories',
	initialState,
	reducers: {
		// Load Categories
		loadDefaultCategories: (state) => {
			state.loading = true;
			state.error = null;
		},
		loadDefaultCategoriesSuccess: (state, action) => {
			state.timeStamp = Date.now();
			state.loading = false;
			state.data = action.payload.data;
			state.loadingComplete = true;
		},
		loadDefaultCategoriesError: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},
		loadAllDefaultCategoryFields: (state) => {
			state.loading = true;
			state.error = null;
		},
		loadDefaultCategoryFieldsSuccess: (state, action) => {
			state.loading = false;
			state.data.forEach((category) => {
				category.fields = action.payload.data.filter(
					(field) => field.defaultCategoryID === category.defaultCategoryID
				);
			});
		},
		loadDefaultCategoryFieldsError: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder.addCase('auth/logout', () => initialState);
	}
});

// Export actions
export const defaultCategoriesActions = defaultCategoriesSlice.actions;

// Export reducer
export default defaultCategoriesSlice.reducer;
